<template>
  <div class="row bg-white max-height-vertical max-height-full box-overflow">
    <div class="row scroll-outer" ref="scrollContainer">
      <div>
        
        <div class="row padding-top-96">
          <div class="span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
            <h1 class="upcase">Post Survey</h1>
            <p>To help us better serve you and your students please tell us how useful/relevant this program is to you.</p>
            <p>Rate your level of agreement with the following statements on a scale of 1-5. 1 being “Strongly Disagree” and 5 being “Strongly Agree.” This training:</p>
            <p v-if="postSurveyError" class="color-red subheader">Please fill out all required fields.</p>
          </div>
        </div>

        <response v-for="(caption, index) in captions" v-bind:key="index" v-bind:ind="(index + 1)" v-bind:caption="caption"></response>

        <div class="row padding-bottom-96"></div>

      </div>
    </div>
  </div>
</template>

<script>
  import surveyResponse from '../../components/organisms/surveyResponse'
  import progressBar from '../../components/organisms/progressBar'
  import vanilla_smooth_scroll from '../../utils/vanilla_smooth_scroll'
  import PerfectScrollbar from 'perfect-scrollbar';

  import {apiUrls} from '../../utils/api_addresses'
  import "babel-polyfill" // axios IE polyfill
  import axios from 'axios'
  axios.defaults.withCredentials = true;

  export default {
    props: ['active'],
    data () {
      return {
        captions: ['Increased my level of commitment to change the way I interact with children who are exhibiting the effects of trauma.', 'Made me feel better prepared to work with students who may have been exposed to violence and trauma.', 'Inspires me to work at my school/district to promote a more compassionate and safer school environment for students, parents, teachers, and staff.', 'Has content that is relevant to my work.', 'Made me interested in a more indepth training on this topic.'],
        psOne: null
      }
    },
    methods: {
      checkIncompleteSurvey () {
        let bool = false
        let postSurvey = this.$store.state.postSurvey

        for( let key in postSurvey) {
          if (!postSurvey[key]) {
            bool = true
          }
        }
        
        return bool
      },
      scrollBarInit () {
        if (window.innerWidth > 1200 && !this.psOne) {
          const containerOne = this.$refs.scrollContainer
          this.psOne = new PerfectScrollbar(containerOne);
        } else if (this.psOne) {
          this.psOne.destroy()
          this.psOne = null
        }
        window.addEventListener('resize', this.scrollBarInit)
      },
      setNextCallback () {
        if(this.active) {
          const nextButtonCallback = () => {
            if(this.checkIncompleteSurvey()) {
              this.$store.commit('setPostSurveyError', true)
              setTimeout(() => {
                if (window.innerWidth < 1200) {
                  vanilla_smooth_scroll(0, 1200)
                } else {
                  vanilla_smooth_scroll(0, 1200, null, this.$refs.scrollContainer)
                }
              }, 800)
              return false
            } else {

              // persist to DB
              console.log('post survey complete.')
              console.log(this.$store.state.postSurveyData)
              axios.post(apiUrls.server.postSurvey, this.$store.state.postSurveyData)
              .catch((err) => {
                console.log(err)
              })
              
              return true
            }

          }

          this.$store.commit('setNextCondition', nextButtonCallback)

          // set scrollbar here.
          setTimeout(() => { 
            this.scrollBarInit()
          }, 1000)
        }
      } 
    },
    computed: {
      postSurveyError () {
        return this.$store.state.postSurveyError
      }
    },
    mounted () {
      this.setNextCallback()
    },
    watch: {
      active () {
        this.setNextCallback()
      }
    },
    components: {
      'response': surveyResponse,
      'progress-bar': progressBar
    }

  }
</script>

<style scoped lang='scss'>

  @import '../../styles/variables';

</style>


// WEBPACK FOOTER //
// post_survey.vue?131e32b0